import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { hideDialog } from "../../../redux/guest-slices/other.slice";
import { useToast } from "../../../hooks/useToast";
import { handleRejectAppointment } from "../../../redux/specialist-slices/Appointment.slice";
import { refresher } from "../../../redux/guest-slices/other.slice";

const RejectAppointmentDialog = () => {
  const [reason, setReason] = useState("");
  const dispatch = useDispatch();
  const toast = useToast();
  const { data, loadings } = useSelector((state) => state.otherSlice);
  const handleClose = () => dispatch(hideDialog());

  const handleReject = async () => {
    if (reason.trim().length < 10) {
      toast.error("Reject reason must be at least 10 characters");
      return;
    }
   
      await dispatch(
        handleRejectAppointment({
          appointmentId: data._id,
          rejectReason: reason.trim(),
        })
      ).unwrap();
      dispatch(refresher());
      handleClose();
   
  };

  return (
    <>
      <DialogTitle>Reject Appointment</DialogTitle>
      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          Please provide a reason for rejecting this appointment (minimum 10
          characters).
        </Typography>
        <TextField
          fullWidth
          multiline
          rows={4}
          label="Reject Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          error={reason.trim().length > 0 && reason.trim().length < 10}
          helperText={
            reason.trim().length > 0 && reason.trim().length < 10
              ? "Reason must be at least 10 characters"
              : ""
          }
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button
          onClick={handleReject}
          color="error"
          variant="contained"
          disabled={
            !reason.trim() || reason.trim().length < 10 || loadings?.reject
          }
        >
          {loadings?.reject ? "Cancelling..." : "Cancel"}
        </Button>
      </DialogActions>
    </>
  );
};

export default RejectAppointmentDialog;
